import { configureTableColumns } from 'utils/table-helpers';

import { useMemo } from 'react';
import { FETCH_ALL_PARAMS } from 'constants/query';
import { useGetCompanyOwnersQuery } from 'features/company-owner/services';
import useTable from 'hooks/useTable.tsx';
import { CompaniesColumns, useCompanyTableColumns } from '../constants/table-settings';

export const useController = () => {
    const { data: companyOwners } = useGetCompanyOwnersQuery(FETCH_ALL_PARAMS);

    const filterSelectOptions = useMemo(() => {
        if (!companyOwners) return;

        return {
            companyOwnerName: companyOwners.content.map((companyOwner) => {
                return {
                    value: companyOwner.id.toString(),
                    label: companyOwner.fullName,
                };
            }),
        };
    }, [companyOwners]);

    const { tableSettings } = useTable<CompaniesColumns>({
        columns: configureTableColumns(useCompanyTableColumns(), filterSelectOptions || {}),
        queryIdentifier: 'companies',
    });

    return {
        tableSettings,
    };
};

export default useController;
